export default "__VITE_ASSET__XycwQYjm__"